<template>
  <div>
    <div id="aboutPanel" class="grid-side-space tabcontent">
      <div class="content">
       <h4 class="blueTitle">{{ $t("cookies.title") }}</h4>
        <br><br>
        <h4 class="blueTitle">{{ $t("cookies.title1") }}</h4><br>
        <p>{{ $t("cookies.title1_text1") }}</p>
        <h4 class="blueTitle">{{ $t("cookies.title2") }}</h4><br>
        <p v-html="$t('cookies.title2_text1')"></p>
        <p>{{ $t("cookies.title2_text2") }}</p>
        <p>{{ $t("cookies.title2_text3") }}</p>

        <table class="cookiesTable">
          <thead>
          <tr>
            <th>{{ $t("cookies.title2_table1") }}</th>
            <th>{{ $t("cookies.title2_table2") }}</th>
            <th>{{ $t("cookies.title2_table3") }}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              {{ $t("cookies.title2_table1_1") }}
            </td>
            <td>
              {{ $t("cookies.title2_table1_2") }}
            </td>
            <td>
              {{ $t("cookies.title2_table1_3") }}
            </td>
          </tr>
          </tbody>
        </table>

        <p>{{ $t("cookies.title2_text4") }}</p>

        <table class="cookiesTable">
          <thead>
          <tr>
            <th>{{ $t("cookies.title2_table1") }}</th>
            <th>{{ $t("cookies.title2_table2") }}</th>
            <th>{{ $t("cookies.title2_table3") }}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              {{ $t("cookies.title2_table2_1") }}
            </td>
            <td>
              {{ $t("cookies.title2_table2_2") }}
            </td>
            <td>
              {{ $t("cookies.title2_table2_3") }}
            </td>
          </tr>
          <tr>
            <td>
              {{ $t("cookies.title2_table2_2_1") }}
            </td>
            <td>
              {{ $t("cookies.title2_table2_2_2") }}
            </td>
            <td>
              {{ $t("cookies.title2_table2_2_3") }}
            </td>
          </tr>
          <tr>
            <td>
              {{ $t("cookies.title2_table2_3_1") }}
            </td>
            <td>
              {{ $t("cookies.title2_table2_3_2") }}
            </td>
            <td>
              {{ $t("cookies.title2_table2_3_3") }}
            </td>
          </tr>
          </tbody>
        </table>

        <p>{{ $t("cookies.title2_text5") }}</p>

        <table class="cookiesTable">
          <thead>
          <tr>
            <th>{{ $t("cookies.title2_table1") }}</th>
            <th>{{ $t("cookies.title2_table2") }}</th>
            <th>{{ $t("cookies.title2_table3") }}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              {{ $t("cookies.title2_table3_1_1") }}
            </td>
            <td>
              {{ $t("cookies.title2_table3_1_2") }}
            </td>
            <td>
              {{ $t("cookies.title2_table3_1_3") }}
            </td>
          </tr>
          <tr>
            <td>
              {{ $t("cookies.title2_table3_2_1") }}
            </td>
            <td>
              {{ $t("cookies.title2_table3_2_2") }}
            </td>
            <td>
              {{ $t("cookies.title2_table3_2_3") }}
            </td>
          </tr>
          <tr>
            <td>
              {{ $t("cookies.title2_table3_3_1") }}
            </td>
            <td>
              {{ $t("cookies.title2_table3_3_2") }}
            </td>
            <td>
              {{ $t("cookies.title2_table3_3_3") }}
            </td>
          </tr>
          <tr>
            <td>
              {{ $t("cookies.title2_table3_4_1") }}
            </td>
            <td>
              {{ $t("cookies.title2_table3_4_2") }}
            </td>
            <td>
              {{ $t("cookies.title2_table3_4_3") }}
            </td>
          </tr>
          <tr>
            <td>
              {{ $t("cookies.title2_table3_5_1") }}
            </td>
            <td>
              {{ $t("cookies.title2_table3_5_2") }}
            </td>
            <td>
              {{ $t("cookies.title2_table3_5_3") }}
            </td>
          </tr>
          </tbody>
        </table>

        <p>{{ $t("cookies.title2_text6") }}</p>

        <table class="cookiesTable">
          <thead>
          <tr>
            <th>{{ $t("cookies.title2_table1") }}</th>
            <th>{{ $t("cookies.title2_table2") }}</th>
            <th>{{ $t("cookies.title2_table3") }}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              {{ $t("cookies.title2_table4_1_1") }}
            </td>
            <td>
              {{ $t("cookies.title2_table4_1_2") }}
            </td>
            <td>
              {{ $t("cookies.title2_table4_1_3") }}
            </td>
          </tr>
          <tr>
            <td>
              {{ $t("cookies.title2_table4_2_1") }}
            </td>
            <td>
              {{ $t("cookies.title2_table4_2_2") }}
            </td>
            <td>
              {{ $t("cookies.title2_table4_2_3") }}
            </td>
          </tr>
          <tr>
            <td>
              {{ $t("cookies.title2_table4_3_1") }}
            </td>
            <td>
              {{ $t("cookies.title2_table4_3_2") }}
            </td>
            <td>
              {{ $t("cookies.title2_table4_3_3") }}
            </td>
          </tr>
          </tbody>
        </table>

        <p>{{ $t("cookies.title2_text7") }}</p>
        <p>{{ $t("cookies.title2_text8") }}</p>
        <p>{{ $t("cookies.title2_text9") }}</p>

      </div>

    </div>
  </div>
</template>
<script>
export default {

};
</script>


<style>
</style>